import React, { Component } from "react";
import { Link } from "react-router-dom";

import Tabs from "@atlaskit/tabs";
import Button from "@atlaskit/button";
import SectionMessage from "@atlaskit/section-message";

import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";

import ProfileFormProfile from "../profileFormProfile/ProfileFormProfile";
import { UserContext } from "../../Context";
import {
  RequiredProfile,
  ProfileDictionary,
  AccentColor,
  SecondaryColor
} from "../../utils/consts";

import ProfileFormReferences from "../profileFormReferences/ProfileFormReferences";
import ProfileFormHistory from "../profileFormHistory/ProfileFormHistory";
import ProfileFormDocs from "../profileFormDocs/ProfileFormDocs";

import "./profileForm.css";

const tabs = ["profile", "docs", "history", "references"];
export default class ProfileForm extends Component {
  state = {};

  static getDerivedStateFromProps(nextProps, prevState) {
    const searchParams = new URLSearchParams(nextProps.location.search);
    const destination = searchParams.getAll("t")[0];
    if (tabs.indexOf(destination) === 0 || !searchParams || !destination)
      return { activeTab: tabs[0] };
    else if (!!searchParams && !!destination && !!tabs.indexOf(destination)) {
      return { activeTab: tabs.indexOf(destination) };
    } else {
      return null;
    }
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(this.props.location.search);
    for (let p of searchParams) {
      if (p[0] === "t" && tabs.indexOf(p[1]) > -1)
        this.setState({ activeTab: tabs.indexOf(p[1]) });
    }
  }

  handleTabSelect = (content, activeTab) => {
    this.setState({ activeTab });
    this.props.history.push(`/profile?t=${tabs[activeTab]}`);
  };

  render() {
    // console.log(this.state);
    return (
      <UserContext.Consumer>
        {userContext => {
          const my = userContext.my || {};
          const den = Object.keys(RequiredProfile).length;
          const num = Object.keys(RequiredProfile).filter(i => !!my[i]).length;
          // const completed = Object.keys(RequiredProfile).filter(i => !!my[i]);
          const incomplete = Object.keys(RequiredProfile).filter(i => !my[i]);
          const percentage = (num / den) * 100;
          const sum = percentage.toFixed(0);
          console.log(sum);
          // const reqd = [...completed, ...incomplete];
          // const items = reqd.map(item => {
          // console.log(item);
          // console.log(!!completed.indexOf(item));
          // return {
          //   id: item,
          //   percentageComplete: !!completed.indexOf(item) ? 100 : 0,
          //   status: !!completed.indexOf(item) ? "disabled" : "unvisited"
          // };
          // });

          return (
            <div className="profile-form">
              <div className={"profile-form__progress-bar"}>
                <SectionMessage
                  appearance={sum < 100 ? "info" : "confirmation"}
                  title={
                    sum < 100
                      ? "Please Complete Your Profile"
                      : "Profile Complete"
                  }
                >
                  <p>
                    {sum < 100
                      ? `Please complete the required fields of your profile to submit a stellar application. Still missing: `
                      : `Great job! Your profile is now complete. Feel free to fill in the additional fields. The more the better in completing a stellar application. Now it's time to find your next home!`}
                    {sum < 100 ? (
                      incomplete.map((item, i) => (
                        <span className="profile-form__section-message-link">
                          <Link
                            className="profile-form__section-message-link"
                            to={`/profile?t=${RequiredProfile[item]}`}
                          >
                            {ProfileDictionary[item]}
                          </Link>
                          {i === incomplete.length - 1 ? "." : ", "}
                        </span>
                      ))
                    ) : (
                      <Link to={"/"}>
                        <Button>Search</Button>
                      </Link>
                    )}
                  </p>
                </SectionMessage>
              </div>
              <Progress
                theme={{
                  active: {
                    color: AccentColor
                  },
                  success: {
                    color: SecondaryColor
                  }
                }}
                percent={sum}
                status={sum > 99 ? "success" : "active"}
              />
              <Tabs
                className="profile-tabs"
                selected={this.state.activeTab}
                onSelect={this.handleTabSelect}
                tabs={[
                  {
                    label: tabs[0],
                    content: <ProfileFormProfile userContext={userContext} />
                  },
                  {
                    label: tabs[1],
                    content: <ProfileFormDocs />
                  },
                  {
                    label: tabs[2],
                    content: <ProfileFormHistory />
                  },
                  {
                    label: tabs[3],
                    content: <ProfileFormReferences />
                  }
                ]}
              />
            </div>
          );
        }}
      </UserContext.Consumer>
    );
  }
}

// {
//   label: tabs[3],
//     content: <ProfileFormFinancial />
// },



// WEBPACK FOOTER //
// ./src/components/profileForm/ProfileForm.js